import { render, staticRenderFns } from "./NewUser.vue?vue&type=template&id=0797af58&scoped=true&lang=pug&"
import script from "./NewUser.vue?vue&type=script&lang=js&"
export * from "./NewUser.vue?vue&type=script&lang=js&"
import style0 from "./NewUser.vue?vue&type=style&index=0&id=0797af58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0797af58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src142773959/src/bsix_meet_client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0797af58')) {
      api.createRecord('0797af58', component.options)
    } else {
      api.reload('0797af58', component.options)
    }
    module.hot.accept("./NewUser.vue?vue&type=template&id=0797af58&scoped=true&lang=pug&", function () {
      api.rerender('0797af58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/autoservice/NewUser.vue"
export default component.exports